<template lang="pug">
#downloads
  .enterprise-clients
    h1 Download redistributable Hubstaff apps
    p Download the desired version of the desktop app on your company computers

    .client-tabs
      ClientSelector(
        v-for="(_value, key) in groupedClients"
        :key="key"
        :class="activeClient === key ? 'active' : ''"
        :client="key"
        @select-client="selectClient"
      )

    .client-info Hubstaff for {{ activeClientName }}
    .client-download-panels
      ClientDownloadPanel(
        v-for="release in groupedClients[activeClient]"
        :key="`${release.platform} - ${release.version}`"
        :release="release"
      )
</template>

<script>
import { mapGetters } from 'vuex';
import ClientSelector from './ClientSelector.vue';
import ClientDownloadPanel from './ClientDownloadPanel.vue';

export default {
  name: 'EnterpriseClients',
  components: {
    ClientSelector,
    ClientDownloadPanel,
  },
  data: () => ({
    activeClient: null,
  }),
  computed: {
    ...mapGetters(['groupedClients']),
    activeClientName() {
      return this.activeClient === 'Mac OS X' ? 'macOS' : this.activeClient;
    },
  },
  created() {
    this.setDefaultClient();
  },
  methods: {
    setDefaultClient() {
      if (/Mac/.test(navigator.platform)) {
        this.activeClient = 'Mac OS X';
      } else if (/Linux/.test(navigator.platform)) {
        this.activeClient = 'Linux';
      } else {
        // Default to Windows
        this.activeClient = 'Windows';
      }
    },
    selectClient(platform) {
      this.activeClient = platform;
    },
  },
};
</script>
